import { defineStyleConfig } from "@chakra-ui/styled-system";

export const closeButtonTheme = defineStyleConfig({
  baseStyle: {
    _hover: {
      bg: "gray.100",
      _disabled: {
        bg: "none",
      },
    },
  },
});
